export interface ICountry {
	zh: string;
	en: string;
	short: string;
	emoji: string;
	phoneCode: string;
}

const countries: ICountry[] = [
	{
		zh: "伊朗",
		en: "Iran",
		short: "IR",
		emoji: "🇮🇷",
		phoneCode: "98",
	},
	{
		zh: "阿拉伯联合酋长国",
		en: "United Arab Emirates",
		short: "AE",
		emoji: "🇦🇪",
		phoneCode: "971",
	},
	{
		zh: "德国",
		en: "Germany",
		short: "DE",
		emoji: "🇩🇪",
		phoneCode: "49",
	},
	{
		zh: "土耳其",
		en: "Turkey",
		short: "TR",
		emoji: "🇹🇷",
		phoneCode: "90",
	},
];

export default countries;
